<div class="breadcrumb-container" [ngClass]="{ 'breadcrumb-container-compact': compactSidebar }" id="breadcrumb">
  <div class="breadcrumb-component">
    <app-breadcrumb
      [parents]="breadcrumbParents"
      [self]="breadcrumbSelf">
    </app-breadcrumb>
    <app-breadcrumb-menu>
    </app-breadcrumb-menu>
  </div>
</div>

<div class="breadcrumb-placeholder"></div>

<div class="animated fadeIn container-horizontal-padding container-vertical-padding">

  <div class="card mb-1">
    <div class="card-header">
      {{'TASK_RECORD_CUSTOM_STATISTICS' | translate}}

      <div class="card-actions d-flex">
      </div><!-- /.card-actions -->
    </div>

    <div class="card-body border-bottom"
         id="task-record-statistics-search-panel">
      <div class="d-flex">
        <div class="col-md-6">
          <angular2-multiselect [data]="statistics" [settings]="dropdownSettingsForSingle"
                                class="form-control"
                                [(ngModel)]="_selectedStatistics"
                                (onSelect)="statSelected($event)"
                                (onDeSelect)="statSelected()"
                                (onRemoteSearch)="loadCustomStatistics($event.target.value)"
                                name="statistics" id="statistics">
          </angular2-multiselect>
        </div>
        <div class="btn-group col-md-6 d-flex justify-content-start">
          <button type="button"
                  *ngIf="_selectedStatistics.length === 0 && rightModel.customStatisticsCreate.hasRight() && !model.createNew"
                  (click)="onCreateClicked()" class="col-md-3 btn btn-primary-green  mr-1">
            {{'COMMON_BUTTON_CREATE' | translate}}
          </button>
          <button type="button"
                  *ngIf="model.selectedStatistics && model.grantedRights.update.hasRight() && !model.updateInProgress"
                  (click)="onUpdateClicked()"
                  class="col-md-3 btn btn-primary-green  mr-1">
            {{'COMMON_BUTTON_EDIT' | translate}}
          </button>
          <button type="button"
                  *ngIf="model.selectedStatistics && model.grantedRights.delete.hasRight() && !(model.editingInProgress)"
                  (click)="onDeleteClicked()" class="col-md-3 btn btn-secondary-warning mr-1">
            {{'COMMON_BUTTON_DELETE' | translate}}
          </button>
          <button type="button" *ngIf="model.editingInProgress"
                  [disabled]="!canSave"
                  (click)="onSaveClicked()"
                  class="col-md-3 btn btn-primary-green mr-1">
            {{'COMMON_BUTTON_SAVE' | translate}}
          </button>
          <button type="button" *ngIf="model.editingInProgress"
                  (click)="onCancelClicked()"
                  class="col-md-3 btn btn-outline-primary">
            {{'COMMON_BUTTON_CANCEL' | translate}}
          </button>
        </div>

      </div>
    </div>

  </div>

  <div class="card mb-1" *ngIf="model.selectedStatistics || model.editingInProgress">
    <div class="card-header">
      {{'TASK_RECORD_CUSTOM_STATISTICS_FILTER_TITLE' | translate}}

      <div class="card-actions d-flex">
      </div><!-- /.card-actions -->
    </div>
    <div class="card-body border-bottom">
      <div>
        <app-dql-search-container #dqlSearchContainer
                                  [rightModel]="rightModel"
                                  [storedQueryDisabled]="true"
                                  (onSearch)="onDqlSearchClicked()"
                                  [showSearchButton]="!model.editingInProgress && model.selectedStatistics !== undefined"
                                  [showDqlQuery]="false"
                                  [canEditFields]="model.editingInProgress"
                                  [dialogContainer]="dqlDialogHolder"></app-dql-search-container>
      </div>
    </div>
  </div>
  <div class="card mb-1" *ngIf="model.editingInProgress">
    <div class="card-header">
      {{'TASK_RECORD_CUSTOM_STATISTICS_DIAGRAM_TITLE' | translate}}

      <div class="card-actions d-flex">
      </div><!-- /.card-actions -->
    </div>
    <div class="card-body border-bottom">
      <div class="row">
        <div class="col-md-3 mb-1 pr-05">
        <button type="button"
                (click)="onNewDiagramClicked()"
                [disabled]="addDiagramDisabled()"
                class="btn btn-secondary w-100">
          {{'TASK_RECORD_CUSTOM_STATISTICS_DIAGRAM_ADD' | translate}}
        </button>
        </div>
        <div *ngFor="let diagram of model.diagramModels; let index = index" class="col-md-3 mb-1 pr-05">
        <div class=" btn btn-secondary w-100"
             (click)="modifyDiagramClicked(diagram)">
          {{diagram.name}}
          <i class="icomoon icomoon-trash cursor-pointer div-icon delete-icon"
             (click)="deleteDiagramClicked(index)"></i>
        </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card mb-1" *ngIf="!model.editingInProgress && displayedDiagrams.length > 0">
    <div class="card-header">
      {{'TASK_RECORD_CUSTOM_STATISTICS_DIAGRAM_TITLE' | translate}}

      <div class="card-actions d-flex">
      </div><!-- /.card-actions -->
    </div>
    <div class="card-body border-bottom">
      <div class="row">
        <div *ngFor="let diagram of displayedDiagrams" class="col-md-4 chart">
          <h5>{{diagram.name}}</h5>
          <google-chart [data]="diagram.chartData"></google-chart>
        </div>
      </div>
    </div>
  </div>

</div>

<app-dql-dialog-container #dqlDialogHolder></app-dql-dialog-container>
